import { getUserInfo } from '@/storage/services/AppBaseConfigService'

class UBT {
  constructor() {
    this._event = null
  }

  sendEvent(key, value = {}) {
    let event = {}
    const eventKey = 'v:bi'
    if (this._event) {
      event = this._event
    } else {
      event = new Event(eventKey)
      this._event = event
    }
    event.key = eventKey
    /**
     * event:{
     *  key: 'v:rms',  //事件主标识，用于matomo监听window事件
     *  value: {
     *      traceKey:String,  //业务标识
     *      ...Otherobject   //其他自定义参数
     *    }
     * }
     *
     */
    let userInfo = getUserInfo() || {}
    event.value = { ...value, ...userInfo, traceKey: key }
    window.dispatchEvent(event)
    console.log('sendEvent', event)
  }
}

export default new UBT()
